import { render, staticRenderFns } from "./efficiency.vue?vue&type=template&id=0c046020&scoped=true&"
import script from "./efficiency.vue?vue&type=script&lang=js&"
export * from "./efficiency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c046020",
  null
  
)

export default component.exports